import { TLHF } from '../../../../../constants';
import { CheckBox, FlexLayout } from '../../../../../components';
import { Plan } from '../Plan';
import PlanModel from '../models/PlanModel';

/**
 * 화면 > 상세 > 호기선택 - 테이블 레이아웃
 * @window w_tb_e035
 * @category 점검계획등록
 */
export const PlanEqupTableHeader: TLHF<PlanModel, Plan> = (scope) => ([
  {
    id: 'chk',
    text: (
      <FlexLayout justify="center" align="center">
        <CheckBox
          noMargin
          value={scope.state.equpChkToggle}
          onChange={async (value) => scope.toggleEqupChk(value)}
        />
      </FlexLayout>
    ),
    width: 10,
    render: (x, rowUpdate) => (
      <CheckBox
        noMargin
        value={x.chk === '1'}
        onChange={(value) => {
          rowUpdate({ chk: value ? '1' : '0' });
        }}
      />
    ),
  },
  {
    id: 'actnm',
    text: '현장명',
    width: 60,
    render: (x) => (
      <FlexLayout
        align="center"
        justify="start"
      >
        {x.actnm}
      </FlexLayout>
    ),
  },
  {
    id: 'equpnm',
    text: '호기명',
    width: 25,
  },
]);
